import { Action, State, StateContext, Store } from "@ngxs/store";
import { Injectable } from "@angular/core";
import { LocalizationService } from "src/app/services/localization/localization.service";
import { AlertService } from "src/app/shared/store/alert/alert.service";
import { CourseResponse } from "../models/course.model";
import { CourseActions } from "./course.actions";
import { CourseService } from "../services/course.service";
import { MappingUtilsService } from "src/app/services/utils/mapping-utils.service";

export class CourseStateModel {
    public courses: CourseResponse[];
    public error: string;
  }

  const defaults = {
    courses: [],
    error: '',
  };

  @State<CourseStateModel>({
    name: 'course',
    defaults,
  })
  @Injectable()
  export class CourseState {
    constructor(
      private alertService: AlertService,
      private localizationService: LocalizationService,
      private courseService: CourseService,
      public store: Store,
    ) {}

    @Action(CourseActions.GetCourses) getCourses(
      ctx: StateContext<CourseStateModel>,
      {schoolId}: CourseActions.GetCourses
    ) {
      return this.courseService
        .getCourses(schoolId)
        .subscribe({
          next: (response) =>
            ctx.dispatch(new CourseActions.GetCoursesSuccess(response)),
          error: (error) =>
            ctx.dispatch(new CourseActions.Error(error)),
        });
    }

    @Action(CourseActions.GetCoursesSuccess)
    getCoursesSuccess(ctx: StateContext<CourseStateModel>,
      { courses }: CourseActions.GetCoursesSuccess
    ) {
      ctx.patchState({
        courses: courses.sort((a, b) => a.courseDescription.localeCompare(b.courseDescription))
      });
    }

    @Action(CourseActions.Error)
    onErrorOcurred(
      ctx: StateContext<CourseStateModel>,
      { error }: CourseActions.Error
    ) {
      ctx.patchState({
        error: error,
      });
      MappingUtilsService.showError(this.getTitle(), error, this.alertService, this.localizationService);
    }

    private getTitle() {
      return this.localizationService.translate('labels.course');
    }
  }
